module.exports = __webpack_public_path__ + "img/20190222_183706_002.d8d91d6c.jpg";